import { Component, Input } from '@angular/core';

import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { PartnerUnique } from '../../../../../model/partner.model';

@Component({
    selector: 'app-logo',
    templateUrl: './logo.component.html',
    styleUrls: ['./logo.component.scss'],
    imports: [TranslateModule, RouterModule],
})
export class LogoComponent {
    @Input({ required: true }) partnersUnique!: PartnerUnique;
}
